import { render } from "./TvmServiceTypes.vue?vue&type=template&id=0a28c6e8&scoped=true"
import script from "./TvmServiceTypes.js?vue&type=script&lang=js&external"
export * from "./TvmServiceTypes.js?vue&type=script&lang=js&external"

import "./TvmServiceTypes.vue?vue&type=style&index=0&id=0a28c6e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a28c6e8"],['__file',"src/Components/ChatWidget/TvmServiceTypes/TvmServiceTypes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a28c6e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a28c6e8', __exports__)) {
    api.reload('0a28c6e8', __exports__)
  }
  
  module.hot.accept("./TvmServiceTypes.vue?vue&type=template&id=0a28c6e8&scoped=true", () => {
    api.rerender('0a28c6e8', render)
  })

}


export default __exports__